import type {CrossSalesPartApiItem, EnrichedCrossSalePart} from '../types';

/**
 * Maps API cross-sale entries and optional key info into enriched card models.
 */
export function mapCrossSaleToEnrichedPart(
    crossSale: CrossSalesPartApiItem,
    keyInfo?: { id?: number; partNo?: string; title?: string } | null,
): EnrichedCrossSalePart {
    const partId = keyInfo?.id ?? crossSale.partId;
    const partNumber = keyInfo?.partNo ?? crossSale.partNumber;
    const title = keyInfo?.title ?? '';
    const image = crossSale.image ?? crossSale.coverImageUrl ?? undefined;

    return {
        partId,
        partNumber,
        description: crossSale.description,
        image,
        title,
        relationTypeId: crossSale.relationTypeId,
        relationTypeTitle: crossSale.relationTypeTitle,
        info: {
            id: partId,
            partNo: partNumber,
            title,
            images: image ? [image] : [null],
            rootCategoryName: '',
            leafCategoryName: '',
            codes: [],
        },
        priceInfo: undefined,
        availabilityInfo: undefined,
    };
}
